import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const Attractions = ({ attractions }) => {
    
  return (
    <StyledAttractions>
      <Container>
        <h2 className="section-title">Popular Attractions</h2>
        <Row>
          {attractions.map((attraction) => (
            <Col lg={4} md={6} sm={12} key={attraction.id}>
              <motion.div
                className="attraction-card"
                initial={{ opacity: 0, translateY: 20 }}
                animate={{ opacity: 1, translateY: 0 }}
                transition={{ duration: 0.5 }}
              >
                <div className="attraction-image">
                  <img src={attraction.image} alt={attraction.title} />
                </div>
                <div className="attraction-content">
                  <h3>{attraction.title}</h3>
                  <p>{attraction.description}</p>
                </div>
              </motion.div>
            </Col>
          ))}
        </Row>
      </Container>
    </StyledAttractions>
  );
};

const StyledAttractions = styled.section`
  padding: 80px 0;
  background: linear-gradient(135deg, #f0f4f8, #e1e8ed);
  
  .section-title {
    text-align: center;
    font-size: 2.5rem;
    margin-bottom: 40px;
    background: linear-gradient(45deg, #2d7ba8, #34495e);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .attraction-card {
    background: white;
    border-radius: 20px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    transition: transform 0.3s;

    &:hover {
      transform: translateY(-10px);
    }

    .attraction-image img {
      width: 100%;
      height: auto;
      border-bottom: 5px solid #2d7ba8;
    }

    .attraction-content {
      padding: 20px;
      text-align: center;

      h3 {
        font-size: 1.5rem;
        color: #2d7ba8;
      }

      p {
        color: #64748b;
        margin-top: 10px;
      }
    }
  }
`;

export default Attractions;